<template>
  <div>
    <b-tabs position="is-centered" v-model="type">
      <b-tab-item :label="$t('recipes') + ` (${numberOfType('Recipe')})`" :visible="hasItemsOfType('Recipe')"/>
      <b-tab-item :label="$t('categories') + ` (${numberOfType('Category')})`" :visible="hasItemsOfType('Category')"/>
      <b-tab-item :label="$t('menus') + ` (${numberOfType('Menu')})`" :visible="hasItemsOfType('Menu')"/>
      <b-tab-item :label="$t('wiki') + ` (${numberOfType('WikiArticle')})`" :visible="hasItemsOfType('WikiArticle')"/>
      <b-tab-item :label="$t('blog articles') + ` (${numberOfType('BlogArticle')})`" :visible="hasItemsOfType('BlogArticle')"/>
      <b-tab-item :label="$t('ingredient') + ` (${numberOfType('Ingredient')})`" :visible="hasItemsOfType('Ingredient')"/>
    </b-tabs>
    <div class="columns is-multiline is-mobile is-centered">
      <div class="column" :class="typeClass" v-for="result in typeItems" :key="result.item.url">
        <menu-preview :menu="result.item" v-if="result.item.__typename === 'Menu'"/>
        <recipe-preview :recipe="result.item" v-if="result.item.__typename === 'Recipe'"/>
        <category-preview :category="result.item" v-if="result.item.__typename === 'Category'"/>
        <ingredient-preview :ingredient="result.item" v-if="result.item.__typename === 'Ingredient'"/>
        <blog-article-preview :article="result.item" v-if="result.item.__typename === 'BlogArticle'"/>
      </div>
    </div>
    <infinite-loading :distance="400" @infinite="loadNextPage">
      <loading-indicator size="is-large" slot="spinner"/>
      <span slot="no-more"/>
      <span slot="no-results"/>
    </infinite-loading>
  </div>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import LoadingIndicator from 'shared/components/LoadingIndicator.vue'
import MenuPreview from '../menu/Preview.vue'
import RecipePreview from '../recipe/Preview.vue'
import CategoryPreview from '../category/Preview.vue'
// import IngredientPreview from '../ingredient/Preview.vue'
import BlogArticlePreview from '../blog/article/Preview.vue'

const TYPE_MAPPING = ['Recipe', 'Category', 'Menu', 'WikiArticle', 'BlogArticle', 'Ingredient']

export default {
  props: {
    endpoint: { type: String, default: () => window.__INIT_DATA.endpoint },
    lang: { type: String, default: () => window.__INIT_DATA.lang }
  },

  components: {
    InfiniteLoading,
    LoadingIndicator,
    MenuPreview,
    RecipePreview,
    CategoryPreview,
    // IngredientPreview,
    BlogArticlePreview
  },

  data(){
    return {
      items: this.getItems(window.__INIT_DATA),
      totalCount: this.getTotalCount(window.__INIT_DATA),
      page: window.__INIT_DATA.page || 1,
      loading: false,
      type: null
    }
  },

  created(){
    const firstItem = this.items[0]
    if(!firstItem) return

    if(this.items.filter(i => i.item.__typename === 'Recipe').length > 0){
      this.type = TYPE_MAPPING.indexOf('Recipe')
      return
    }

    let type = firstItem.item.__typename
    if(type === 'Recipe' && firstItem.item.type === 'wiki') type = 'WikiArticle'
    this.type = TYPE_MAPPING.indexOf(type)
  },

  methods: {
    loadNextPage($state) {
      if(this.loading) return
      if(this.totalCount < 32) return $state.complete()

      this.page++
      this.loading = true

      return axios.get(this.endpointUrl())
      .then(result => {
        const items = this.getItems(result.data)
        this.items = this.items.concat(items)
        this.totalCount = this.getTotalCount(result.data)
        this.page = result.data.page
        this.loading = false

        if(this.totalCount <= this.items.length || items.length === 0) $state.complete()
        else $state.loaded()
      })
    },


    endpointUrl(){
      if(window.__INIT_DATA.text) return `/${this.lang}/${this.endpoint}/${window.__INIT_DATA.text}/${this.page}.json`
    },

    getItems(data){
      if(data.search) return data.search.nodes
      return []
    },

    getTotalCount(data){
      if(data.search) return data.search.totalCount
      return Infinity
    },

    itemsOfType(itemType){
      return this.items.filter(item => {
        let type = item.item.__typename
        if(type === 'Recipe' && item.item.type === 'wiki') type = 'WikiArticle'
        return type === itemType
      })
    },

    numberOfType(type){
      return this.itemsOfType(type).length
    },

    hasItemsOfType(type){
      return this.numberOfType(type) > 0
    }
  },

  computed: {
    typeItems(){
      return this.itemsOfType(TYPE_MAPPING[this.type])
    },

    typeClass(){
      if(TYPE_MAPPING[this.type] === 'Recipe') return 'is-half-mobile is-one-quarter-tablet'
      if(TYPE_MAPPING[this.type] === 'WikiArticle') return 'is-half-mobile is-one-quarter-tablet'
      if(TYPE_MAPPING[this.type] === 'Menu') return 'is-12-mobile is-half-tablet'

      return 'is-one-third-tablet'
    }
  }
}
</script>

<style>
  .infinite-loading-container{
    width: 100%;
    margin-top: 4em;
  }
</style>



// WEBPACK FOOTER //
// src/components/search/List.vue